import { FC, ReactElement, ReactNode } from 'react';
import { styled, Box } from '@mui/material';

interface Props {
  title: ReactNode
  description: ReactNode
  icon: ReactElement
  amount?: number
}
const StyledContainer = styled(Box)(({ theme  }) => ({

    ".notification-retard-amount": {
      marginBottom: '12px',
     float: 'right'
    },
    ".notification-retard-amount .notification-retard-button": {
      display: 'flex',
      alignstems: 'center',
    },
    ".notification-retard-payment" : {
      padding: "9px",
      borderRadius: "25px",
    },
    ".notification-retard-title":{
      color:'white',
      fontWeight: 200,
      fontSize: '1.2rem',
     },
    " .notification-retard-details" :{
      display: 'flex',
      justifyContent: 'space-between'
    },
    ".notification-retard-button":{
      padding: '0.8rem 2rem',
      backgroundColor: '#1A1A1A',
      color: 'white',
      border: 'none',
      borderRadius: '9px',
      cursor: 'pointer',
    },
  ".notification-description": {
    fontSize: '1rem',
    color: '#949494',
  },
  ".notification-amount": {
    fontWeight: 200,
    color: '#FBDA61',
    fontSize: '2rem',
    marginTop: '0.5rem',
  },
  ".mobiletitle": {
    textTransform: 'none'  
  },
  '@media (max-width: 600px)': {
    ".mobiletitle": {
      display: 'none', 
    },
    ".notification-retard-button": {
      padding: theme.spacing(1), 
      minWidth: theme.spacing(5), 
      width: theme.spacing(5), 
      height: theme.spacing(5), 
      borderRadius: '13%', 
      backgroundColor: '#1A1A1A',
      '& svg': { 
        fontSize: '1.2rem', 
      },
      display: 'flex',
      justifyContent: 'center', 
      alignItems: 'center', 
    },
  },
  '@media (min-width: 601px) and (max-width: 1024px)': {
  },
}));

const NotificationContainer: FC<Props> = ({ title, description, icon, amount }) => {
  return (
    <StyledContainer>
       <Box className="notification-retard-payment">
            <Box className="notification-retard-title">{title}</Box>
         <Box className="notification-description">
        {description}
        </Box>
            <Box className="notification-retard-details">
            {amount !== undefined ? <Box className="notification-amount"> {icon} {amount}$</Box>: null}
              <Box className="notification-retard-amount"> 
                </Box>
            </Box>
          </Box>
    </StyledContainer>
  )
}

export default NotificationContainer
